import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Home from "../pages/Home";
import Bio from "../pages/Bio";
import Contatti from "../pages/Contatti";
import { GetRouteByName } from "./Routes";
import Servizi from "../pages/Servizi";
import ChiSiamo from "../pages/ChiSiamo";
import LoStudio from "../pages/LoStudio";

function AppMainBodyRoutes() {
  return (
    <Routes>
      <Route path="/redirect-page" element={<Navigate to="/error-page" />} />
      <Route path={GetRouteByName("Home")} element={<Home />} />
      <Route path={GetRouteByName("Bio")} element={<Bio />} />
      <Route path={GetRouteByName("Servizi")} element={<Servizi />} />
      <Route path={GetRouteByName("LoStudio")} element={<LoStudio />} />
      <Route path={GetRouteByName("Contatti")} element={<Contatti />} />
      <Route path={GetRouteByName("ChiSiamo")} element={<ChiSiamo />} />
      {/* <Route path="/addpost" element={<AddPostForm />} /> */}
    </Routes>
  );
}

export default AppMainBodyRoutes;
